/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable react-hooks/exhaustive-deps */
import React, { lazy, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import UploadSuccess from 'src/components/Covie/components/UploadSuccess';
import { LearnFooter } from 'src/components/Footer/LearnFooter';
import { LearnHeader } from 'src/components/Header/LearnHeader';
import { APPLICATION_BY_ID } from 'src/configs/APISchemas/ApplicationById';
import { CREATE_COMMUNITY } from 'src/configs/APISchemas/CreateCommunity';
import { GET_BUILDING } from 'src/configs/APISchemas/GetBuilding';
import Analytics from 'src/helpers/Analytics';
import { GraphQLRequest } from 'src/helpers/GraphQLRequest';
import AlreadyCoveragePurchased from 'src/pages/AlreadyCoveragePurchased/AlreadyCoveragePurchased';
import AlreadyCoverageVerified from 'src/pages/AlreadyCoverageVerified/AlreadyCoverageVerified';
import CoverageVerified from 'src/pages/CoverageVerified/CoverageVerified';
import Error404 from 'src/pages/Error404/Error404';
import NoBuildingLocated from 'src/pages/NoBuildingLocated/NoBuildingLocated';
import NoPolicyLocated from 'src/pages/NoPolicyLocated/NoPolicyLocated';
import {
  UpdateApplication,
  UpdateApplicationRoute,
} from 'src/redux/actions/Application';
import { Store } from 'src/types';
import { Footer } from '../../components/Footer/Footer';
import { Header } from '../../components';
import Compliance from '../../pages/Compliance/Compliance';
import ComplianceForm from '../../pages/Compliance/ComplianceForm';
import { ComplianceWelcome } from '../../pages/ComplianceWelcome';
import { ConsumerReports } from '../../pages/ConsumerReports';
import CoverageErrors from '../../pages/CoverageErrors/CoverageErrors';
import PaymentMSI from '../../pages/PaymentMSI/PaymentMSI';
import { RXRApplication } from '../../pages/RXRApplication';
import { Terms } from '../../pages/Terms';
import { usePrefillApplication } from "../../helpers/usePrefillApplication";

const StartApplication = lazy(
  () => import('../../pages/StartApplication/StartApplication'),
);
const LearnPage = lazy(() => import('../../pages/Learn/Learn'));
const QuoteInformation = lazy(
  () => import('../../pages/QuoteInformation/QuoteInformation'),
);
const CoveragesDetails = lazy(
  () => import('../../pages/CoveragesDetails/CoveragesDetails'),
);
const Confirmation = lazy(
  () => import('../../pages/Confirmation/Confirmation'),
);
const Building = lazy(() => import('../../pages/Building/Building'));
const Organisation = lazy(() => import('../../pages/Building/Organisation'));
const CompanyByName = lazy(() => import('../../pages/Building/CompanyByName'));

const ACCEPTED_START_ROUTES = new Set(['/service', '/company', '/learn', '/rxr', '/compliance', '/compliance/welcome', '/building', '/organisation'])
const ROUTES_REDIRECTING_TO_LEARN_PAGE_IF_FIRST_TIME = new Set(['/start-application'])

export const PublicRoutes = () => {
  usePrefillApplication();
  const history = useHistory();
  const application = useSelector((store: Store) => store.application);
  const dispatch = useDispatch();
  const [buildRoutes, setBuildRoutes] = useState<boolean>(false);

  const checkForAppState = async () => {
    if (history.location.search.includes('?appId=')) {
      const appId = history.location.search.split('?appId=')[1];
      const startApp = async () => {
        const appIdMutation = APPLICATION_BY_ID(appId);
        const appResponse = await GraphQLRequest(appIdMutation);
        let { application } = appResponse;
        const buildingQuery = GET_BUILDING(application.buildingId);
        const buildingResponse = await GraphQLRequest(buildingQuery);
        if (buildingResponse?.building) {
          const building = buildingResponse.building;
          application = {
            ...application,
            buildingName: building.name,
            addressName: building.name,
            address: {
              ...building.fullAddress,
              state: building.fullAddress.region,
            },
            buildingAddress: {
              value: {
                ...building.fullAddress,
                state: building.fullAddress.region,
              },
            },
          };
        }
        dispatch(UpdateApplication(application));
        if (application.coverageStart === null) {
          return history.replace('/quote-information');
        } else if (application.status === 'inProgress') {
          const buidlingDetails = application.buildingAddress.value;
          const communityMutation = CREATE_COMMUNITY({
            communityName:
              application.buildingName || application.addressName || '',
            coverageStart: application.coverageStart,
            building: {
              yearBuilt: parseInt(buidlingDetails['yearBuilt'] || '2000'),
              zipCode: buidlingDetails.postalCode,
              addressState: buidlingDetails.state,
              addressCity: buidlingDetails.municipality,
              addressStreet: buidlingDetails.street,
            },
          });
          const communityResponse = await GraphQLRequest(communityMutation);
          dispatch(
            UpdateApplication({
              ...application,
              communityId: communityResponse.createCommunity.communityId,
            }),
          );
          return history.replace('/coverages-details');
        } else if (application.status === 'compliant') {
          let subscription = '',
            subscribedPlan: any = '';
          if (application.installment) {
            if (application.installment.length) {
              subscription = 'MONTHLY';
              subscribedPlan = application.paymentPlans.filter(
                (plan: any) => plan.paymentPlanCd === 'Monthly',
              )[0];
            } else {
              subscription = 'ANNUAL';
              subscribedPlan = application.paymentPlans.filter(
                (plan: any) => plan.paymentPlanCd === 'Annual',
              )[0];
            }
          }
          dispatch(
            UpdateApplication({
              ...application,
              subscription,
              subscribedPlan,
            }),
          );
          return history.replace('/confirmation?persist=true');
        } else if (application.status === 'quoted') {
          return history.replace('/payment');
        }
        history.replace({
          search: '',
        });
        window.location.reload();
      };
      void startApp();
      return;
    }
    setBuildRoutes(true);
  };

  useEffect(() => {
    const pathName = history.location.pathname;


    (async () => {
      await checkForAppState();
    })();
    Analytics.trackCurrentPage(pathName);

    if(pathName != '/confirmation' && pathName != '/already-purchased' && application.data.purchased){
      dispatch(UpdateApplicationRoute('/already-purchased'));
      window.location.replace('/already-purchased')
      return
    }

    if (ACCEPTED_START_ROUTES.has('/'+pathName.split('/')[1])) {
      localStorage.setItem('EXISTING_TIME_USER', '/start-application');
      dispatch(UpdateApplicationRoute(pathName));
      history.push(pathName);
      return;
    }

    if (application?.currentRoute) {
      history.push(application.currentRoute);
    }

    if(ROUTES_REDIRECTING_TO_LEARN_PAGE_IF_FIRST_TIME.has('/'+pathName.split('/')[1]) &&
      !localStorage.getItem('EXISTING_TIME_USER')){
      localStorage.setItem('EXISTING_TIME_USER', pathName);
      history.replace('/learn');
    }

  }, []);

  function trackOnClick(event: any) {
    if (event.target.form) {
      if (event.target?.nodeName === 'INPUT') {
        Analytics.trackEvent(`${event.target.form.name} FormInteractions`, {
          input: event.target.name,
          value: event.target.value,
        });
      }
    }
  }
  if (!buildRoutes) {
    return <></>;
  }

  return (
    <div
      className="shell_container"
      id="shell_container"
      onClick={(event) => trackOnClick(event)}
    >
      <Switch>
        <Route path="/learn">
          <React.Suspense fallback={<></>}>
            <LearnHeader />
            <LearnPage />
          </React.Suspense>
          <LearnFooter />
        </Route>
        <Route path="/building/:type/:id" exact={true}>
          <React.Suspense fallback={<></>}>
            <Building />
          </React.Suspense>
          <Footer withMarginTop={true} withBackgroundColor={false}/>
        </Route>
        <Route path="/building/:id">
          <React.Suspense fallback={<></>}>
            <Building />
          </React.Suspense>
          <Footer withMarginTop={true} withBackgroundColor={false}/>
        </Route>

        <Route path="/organisation/:id">
          <React.Suspense fallback={<></>}>
            <Organisation />
          </React.Suspense>
          <Footer withMarginTop={true} withBackgroundColor={false}/>
        </Route>

        <Route path="/company/:name/:flow?">
          <React.Suspense fallback={<></>}>
            <CompanyByName />
          </React.Suspense>
          <Footer withMarginTop={true} withBackgroundColor={false}/>
        </Route>

        {/* Compliance Routes */}
        <Route exact={true} path="/compliance/welcome">
          <React.Suspense fallback={<></>}>
            <Header />
            <ComplianceWelcome />
          </React.Suspense>
          <Footer withMarginTop={true} withBackgroundColor={false}/>
        </Route>
        <Route exact={true} path="/compliance">
          <Header />
          <ComplianceForm />
          <Footer withMarginTop={true} withBackgroundColor={false}/>
        </Route>
        <Route exact={true} path="/compliance/verified">
          <Header />
          <CoverageVerified />
          <Footer withMarginTop={false} withBackgroundColor={false}/>
        </Route>
        <Route exact={true} path="/compliance/already-verified">
          <Header />
          <AlreadyCoverageVerified />
          <Footer withMarginTop={false} withBackgroundColor={false}/>
        </Route>
        <Route exact={true} path="/compliance/nopolicylocated">
          <Header />
          <NoPolicyLocated />
          <Footer withMarginTop={false} withBackgroundColor={false}/>
        </Route>
        <Route exact={true} path="/compliance/nobuildinglocated">
          <Header />
          <NoBuildingLocated />
          <Footer withMarginTop={false} withBackgroundColor={false}/>
        </Route>
        <Route exact={true} path="/compliance/coverage-not-compliant">
          <Header />
          <CoverageErrors />
          <Footer withMarginTop={true} withBackgroundColor={false}/>
        </Route>
        <Route exact={true} path="/compliance/upload-success">
          <Header />
          <UploadSuccess />
          <Footer withMarginTop={false} withBackgroundColor={false}/>
        </Route>

        <Route path="/compliance/:covie_id">
          <Header />
          <Compliance />
        </Route>
        {/* <Route path="/compliances/:application_id">
            <Compliance />
          </Route> */}

        {/*  Application Process */}
        <Route path="/start-application">
          <React.Suspense fallback={<></>}>
            <Header />
            <StartApplication />
          </React.Suspense>
          <Footer withMarginTop={true} withBackgroundColor={false}/>
        </Route>

        {/* RXR Application Process */}
        <Route path="/rxr" exact={true}>
          <Header />
          <RXRApplication />
          <Footer withMarginTop={true} withBackgroundColor={false}/>
        </Route>
        <Route exact={true} path="/rxr/:name">
          <Header />
          <RXRApplication />
          <Footer withMarginTop={true} withBackgroundColor={false}/>
        </Route>

        {/* Common Application Process */}
        <Route path="/quote-information">
          <React.Suspense fallback={<></>}>
            <Header />
            <QuoteInformation />
          </React.Suspense>
          <Footer withMarginTop={true} withBackgroundColor={false}/>
        </Route>

        <Route path="/coverages-details">
          <React.Suspense fallback={<></>}>
            <Header />
            <CoveragesDetails />
          </React.Suspense>
          <Footer withMarginTop={true} withBackgroundColor={false}/>
        </Route>
        <Route exact path="/payment">
          <React.Suspense fallback={<></>}>
            <Header />
            <PaymentMSI />
          </React.Suspense>
          <Footer withMarginTop={true} withBackgroundColor={false}/>
        </Route>
        <Route path="/confirmation">
          <React.Suspense fallback={<></>}>
            <Header />
            <Confirmation />
          </React.Suspense>
          <Footer withMarginTop={true} withBackgroundColor={false}/>
        </Route>
        <Route exact={true} path="/already-purchased">
          <Header />
          <AlreadyCoveragePurchased />
          <Footer withMarginTop={false} withBackgroundColor={false}/>
        </Route>

        {/* Other Routes */}
        <Route path="/error">
          <Header />
          <Error404 />
          <Footer withMarginTop={false} withBackgroundColor={true}/>
        </Route>
        <Route path="/service/terms-and-conditions">
          <Header />
          <Terms />
        </Route>
        <Route path="/service/consumer-reports-notice">
          <Header />
          <ConsumerReports />
        </Route>

        <Route path="*">
          <Redirect to="/start-application" />
        </Route>
      </Switch>
    </div>
  );
};
